import React, { useEffect, useState } from 'react';

import Button from '@amzn/meridian/button';
import Column from '@amzn/meridian/column';
import Modal, { ModalFooter } from '@amzn/meridian/modal';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import Textarea from '@amzn/meridian/textarea';
import { TOAST_TIMEOUT } from 'src/config/Toast';
import { setJmrResults } from 'src/store/newJmrPageSlice/newJmrPageSlice';
import { useAppDispatch, useAppSelector } from 'src/store/store';
import { createToast } from 'src/store/toastsSlice';
import { type TableDataRow } from 'src/utils/jmrUtils';

interface ApplyModificationsModalProps {
  jobToModify: TableDataRow | null;
  isOpen: boolean;
  onClose: () => void;
}
const T2PlusModificationsModal = ({ jobToModify, isOpen, onClose }: ApplyModificationsModalProps) => {
  const [modificationNotes, setModificationNotes] = useState<string>('');
  const { jmrResults } = useAppSelector((state) => state.newJmrPage);
  const dispatch = useAppDispatch();

  useEffect(() => {
    setModificationNotes(jobToModify?.modificationNotes ?? '');
  }, [jobToModify]);

  const isValid = () => modificationNotes.trim().length > 0;

  const onSaveAndApply = () => {
    const modifiedJmrResults = jmrResults.map((row) =>
      jobToModify?.id === row.id ? { ...row, modificationNotes, isChecked: true } : { ...row, isChecked: false },
    );
    dispatch(setJmrResults(modifiedJmrResults));
    dispatch(
      createToast({
        type: 'success',
        message: 'Job was modified and selected',
        timeout: TOAST_TIMEOUT,
      }),
    );
    onClose();
  };

  return (
    <Modal
      title={`Information Required: ${jobToModify?.name}`}
      open={isOpen}
      onClose={onClose}
      closeLabel="Close"
      aria-describedby="modal-description"
      width="700px"
      scrollContainer="modal"
    >
      {!!jobToModify && (
        <Column spacing={'450'}>
          <Text type="b300">Detail all modifications to be made to the associates home assignment.</Text>
          <Textarea
            value={modificationNotes}
            onChange={setModificationNotes}
            placeholder="Enter modification (required)..."
          />
        </Column>
      )}
      <ModalFooter>
        <Row alignmentHorizontal="end" widths="fit">
          <Button type="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button
            data-cy={'new-jmr__results__apply-modifications'}
            type="primary"
            disabled={!isValid()}
            onClick={() => onSaveAndApply()}
          >
            Apply & Select
          </Button>
        </Row>
      </ModalFooter>
    </Modal>
  );
};

export default T2PlusModificationsModal;
